import API from './api.js'

export default {
    async postMachine(data) {
        try {
            let response = await API.HTTPS.post('/machines', data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async putMachine(id, data) {
        try {
            let response = await API.HTTPS.put('/machines/' + id, data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async deleteMachine(id) {
        try {
            let response = await API.HTTPS.delete('/machines/' + id)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getSamples(machineId) {
        try {
            let response = await API.HTTPS.get('/machines/' + machineId + '/samples?page=1&pagesize=10000')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async getMeasurements(machineId) {
        try {
            let response = await API.HTTPS.get('/machines/' + machineId + '/measurements?page=1&pagesize=100000')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async getEvents(machineId) {
        try {
            let response = await API.HTTPS.get('/machines/' + machineId + '/events')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async search(name) {
        try {
            let response = await API.HTTPS.get('/machines/search?nameStartAs=' + name)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async searchUIN(uin) {
        try {
            let response = await API.HTTPS.get('/machines/searchuin?uin=' + uin)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async searchUID(uid) {
        try {
            let response = await API.HTTPS.get('/machines/searchuid?uid=' + uid)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async getSensors(machineId) {
        try {
            let response = await API.HTTPS.get('/machines/' + machineId + '/sensors')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async postSensor(data) {
        try {
            let response = await API.HTTPS.post('/machines/' + data.machine.id + '/sensors', data)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
    
    async putSensor(data) {
        try {
            let response = await API.HTTPS.put('/machines/' + data.machine.id + '/sensors/' + data.id, data)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async deleteSensor(data) {
        try {
            let response = await API.HTTPS.delete('/machines/' + data.machine.id + '/sensors/' + data.id)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}